@if (isValidatingStore()) {
  <div class="store-loading-overlay" aria-busy="true" aria-label="Validating store">
    <div class="store-loading-spinner"></div>
  </div>
} @else if (storeStatus() === 'disabled' || storeStatus() === 'not-found') {
  <div
    class="store-access-overlay"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="storeStatus() === 'not-found' ? 'sa-nf-title' : 'sa-dis-title'"
    [attr.aria-describedby]="storeStatus() === 'not-found' ? 'sa-nf-desc' : 'sa-dis-desc'"
  >
    <div class="store-access-dialog">
      <div class="store-access-icon">
        <app-icon name="alert-circle" [size]="40" />
      </div>

      @if (storeStatus() === 'not-found') {
        <h2 class="store-access-title" id="sa-nf-title">No Store Configured</h2>
        <p class="store-access-message" id="sa-nf-desc">
          No store is configured for your account. Please contact your administrator for assistance.
        </p>
      } @else {
        <h2 class="store-access-title" id="sa-dis-title">Store Not Accepting Consignments</h2>
        <p class="store-access-message" id="sa-dis-desc">
          Your store is currently not accepting consignments. Please contact your administrator for assistance.
        </p>
      }

      <button mat-raised-button color="primary" (click)="onLogout()">OK</button>
    </div>
  </div>
}

@if (showShell()) {
  <app-layout moduleLabel="Internal Portal" [sections]="sections">
    <router-outlet />
  </app-layout>
} @else {
  <router-outlet />
}

<app-required-print-format-modal />
